import React from "react";
import styled from "styled-components";

interface AvatarProps {
  url: string;
  bgColor?: string;
}

const Avatar = ({ url, bgColor, ...props }: AvatarProps) => {
  return (
    <AvatarContainer bgColor={bgColor}>
      <Image
        src={
          url ||
          "https://previews.123rf.com/images/nexusby/nexusby1810/nexusby181000286/111362910-default-avatar-placeholder-profile-icon-male.jpg"
        }
        alt="no Image"
      />
    </AvatarContainer>
  );
};

export default Avatar;

const AvatarContainer = styled.div<Omit<AvatarProps, "url">>`
  vertical-align: middle;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background-color: ${(props) => props.bgColor};
`;

const Image = styled.img`
  width: 36px;
  height: 36px;
  border-radius: 50%;
`;
